var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiSimbol({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2960_6495)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2960_6495",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.132324H16V16.1323H0V0.132324Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2960_6495)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16.1323C10.1217 16.1323 12.1566 15.2895 13.6569 13.7892C15.1571 12.2889 16 10.2541 16 8.13232C16 6.01059 15.1571 3.97576 13.6569 2.47547C12.1566 0.975179 10.1217 0.132324 8 0.132324C5.87827 0.132324 3.84344 0.975179 2.34315 2.47547C0.842855 3.97576 0 6.01059 0 8.13232C0 10.2541 0.842855 12.2889 2.34315 13.7892C3.84344 15.2895 5.87827 16.1323 8 16.1323ZM8 14.1323C8.78793 14.1323 9.56815 13.9771 10.2961 13.6756C11.0241 13.3741 11.6855 12.9321 12.2426 12.375C12.7998 11.8178 13.2417 11.1564 13.5433 10.4284C13.8448 9.70047 14 8.92026 14 8.13232C14 7.34439 13.8448 6.56418 13.5433 5.83622C13.2417 5.10827 12.7998 4.44684 12.2426 3.88968C11.6855 3.33253 11.0241 2.89058 10.2961 2.58905C9.56815 2.28752 8.78793 2.13232 8 2.13232C6.4087 2.13232 4.88258 2.76447 3.75736 3.88968C2.63214 5.0149 2 6.54103 2 8.13232C2 9.72362 2.63214 11.2497 3.75736 12.375C4.88258 13.5002 6.4087 14.1323 8 14.1323Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.465 10.1323H4.535C4.88599 10.7407 5.39105 11.2458 5.99934 11.5969C6.60762 11.948 7.29766 12.1327 8 12.1323C9.48 12.1323 10.773 11.3283 11.465 10.1323ZM6 7.13232C6 7.39754 5.89464 7.65189 5.70711 7.83943C5.51957 8.02697 5.26522 8.13232 5 8.13232C4.73478 8.13232 4.48043 8.02697 4.29289 7.83943C4.10536 7.65189 4 7.39754 4 7.13232C4 6.86711 4.10536 6.61275 4.29289 6.42522C4.48043 6.23768 4.73478 6.13232 5 6.13232C5.26522 6.13232 5.51957 6.23768 5.70711 6.42522C5.89464 6.61275 6 6.86711 6 7.13232ZM12 7.13232C12 7.39754 11.8946 7.65189 11.7071 7.83943C11.5196 8.02697 11.2652 8.13232 11 8.13232C10.7348 8.13232 10.4804 8.02697 10.2929 7.83943C10.1054 7.65189 10 7.39754 10 7.13232C10 6.86711 10.1054 6.61275 10.2929 6.42522C10.4804 6.23768 10.7348 6.13232 11 6.13232C11.2652 6.13232 11.5196 6.23768 11.7071 6.42522C11.8946 6.61275 12 6.86711 12 7.13232Z",
    fill: "#636363"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2960_6495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.132324)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSimbol);
export default __webpack_public_path__ + "static/media/EmojiSimbol.2a8e8214ba659aa4d2a640d9fcb3d183.svg";
export { ForwardRef as ReactComponent };